(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subscription', {
            parent: 'entity',
            url: '/subscription?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.subscription.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription/subscriptions.html',
                    controller: 'SubscriptionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subscription');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('subscription-detail', {
            parent: 'entity',
            url: '/subscription/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.subscription.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/subscription/subscription-detail.html',
                    controller: 'SubscriptionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subscription');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Subscription', function($stateParams, Subscription) {
                    return Subscription.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('subscription.new', {
            parent: 'subscription',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startDate: null,
                                endDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: true });
                }, function() {
                    $state.go('subscription');
                });
            }]
        })
        .state('subscription.edit', {
            parent: 'subscription',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-dialog.html',
                    controller: 'SubscriptionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('subscription.delete', {
            parent: 'subscription',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/subscription/subscription-delete-dialog.html',
                    controller: 'SubscriptionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Subscription', function(Subscription) {
                            return Subscription.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subscription', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
